module.exports = __webpack_public_path__ + "img/cert231.21e5ff9b.jpg";